import { useMemo } from 'react';

export const useNotesCalculations = (allNotes) => {
  const stats = useMemo(() => {
    if (allNotes.length === 0) return null;

    const notesValues = allNotes.map(n => n.note);
    const moyenne = notesValues.reduce((sum, note) => sum + note, 0) / notesValues.length;
    const min = Math.min(...notesValues);
    const max = Math.max(...notesValues);
    const reussite = notesValues.filter(note => note >= 10).length;
    const echec = notesValues.filter(note => note < 10).length;
    
    // Distribution par tranches
    const distributions = {
      'Excellent (16-20)': notesValues.filter(n => n >= 16).length,
      'Bien (14-16)': notesValues.filter(n => n >= 14 && n < 16).length,
      'Assez Bien (12-14)': notesValues.filter(n => n >= 12 && n < 14).length,
      'Passable (10-12)': notesValues.filter(n => n >= 10 && n < 12).length,
      'Insuffisant (8-10)': notesValues.filter(n => n >= 8 && n < 10).length,
      'Très Insuffisant (<8)': notesValues.filter(n => n < 8).length,
    };

    // Données pour les graphiques
    const distributionData = Object.entries(distributions).map(([name, value]) => ({
      name,
      value,
      percentage: Math.round((value / allNotes.length) * 100)
    }));

    const histogrammeData = [];
    for (let i = 0; i <= 20; i += 2) {
      const count = notesValues.filter(n => n >= i && n < i + 2).length;
      histogrammeData.push({
        tranche: `${i}-${i + 2}`,
        count,
        percentage: Math.round((count / allNotes.length) * 100)
      });
    }

    return {
      total: allNotes.length,
      moyenne: Math.round(moyenne * 100) / 100,
      min,
      max,
      reussite,
      echec,
      pourcentageReussite: Math.round((reussite / allNotes.length) * 100),
      distributions,
      distributionData,
      histogrammeData
    };
  }, [allNotes]);

  return { stats };
}; 